import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $('.sidebar').sidebar('setting', 'transition', 'overlay')
    .sidebar('attach events', '.main.menu .item.open-sidebar')
  }
}

